module.exports = __webpack_public_path__ + "img/4_1.5fcf8f32.png";